var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _mask, _g, _path26, _mask2, _g2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g3, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _mask3, _g4, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _mask4, _g5, _path113, _path114, _path115, _path116, _mask5, _g6, _path117, _rect, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _mask6, _g7, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1136,
    height: 593,
    viewBox: "0 0 1136 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1087 571H30C40.0254 501.996 77.3758 442.302 142.051 391.919C239.064 316.343 313.462 413.421 501.614 205.528C689.766 -2.36391 778.681 -19.9484 855.582 13.1439C932.483 46.2362 946.091 193.081 1069.93 238.229C1152.49 268.328 1156.88 386.021 1087 571ZM250.743 240.377C198.13 178.383 266.01 93.8454 334.343 61.7513C402.675 29.6572 472.998 72.8547 437.465 145.734C401.932 218.614 303.356 302.371 250.743 240.377Z",
    fill: "#F2F6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9169 186.269C81.9169 186.269 91.084 183.59 91.084 177.64C91.084 171.689 86.353 169.636 83.3965 168.961C81.7499 163.696 77.7519 158.338 65.6335 160.486C53.515 162.635 43.7477 173.393 41.5507 183.411C39.3538 193.43 40.8813 213.95 32.3924 224.87C23.9035 235.791 37.8746 259.148 69.7399 252.399C101.605 245.651 98.996 227.126 90.2385 216.985C81.4811 206.843 81.9169 186.269 81.9169 186.269Z",
    fill: "#3542A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8123 197.726V228.413H77.4607V206.444L54.8123 197.726Z",
    fill: "#FB6464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4605 213.069C77.4605 213.069 67.9628 213.81 58.4651 207.839C63.6164 215.919 77.4605 226.13 77.4605 226.13V213.069Z",
    fill: "#D15959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1926 183.938C84.1926 183.938 85.4357 200.109 84.1926 206.589C82.9494 213.069 77.78 213.81 73.597 213.81C69.4141 213.81 54.8123 213.95 54.8123 197.726C54.8123 197.726 50.1841 197.171 50.1841 192.174C50.1841 187.178 54.9425 189.592 59.0074 189.592C63.0722 189.592 73.853 188.517 77.8043 176.104C77.8043 176.104 78.9597 180.234 80.7591 182.115C82.4193 183.852 84.1926 183.938 84.1926 183.938Z",
    fill: "#FB6464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4651 208.378C58.4651 208.378 60.9572 212.542 68.4076 213.81",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2358 187.783C65.6666 187.745 67.9573 186.018 71.8171 187.564",
    stroke: "#1E2243",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5605 187.679C80.8488 187.679 82.4705 186.494 84.9441 187.956",
    stroke: "#1E2243",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0646 193.118C81.6699 193.118 82.1605 192.628 82.1605 192.023C82.1605 191.418 81.6699 190.928 81.0646 190.928C80.4594 190.928 79.9688 191.418 79.9688 192.023C79.9688 192.628 80.4594 193.118 81.0646 193.118Z",
    fill: "#1E2243"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8364 193.118C71.4416 193.118 71.9323 192.628 71.9323 192.023C71.9323 191.418 71.4416 190.928 70.8364 190.928C70.2311 190.928 69.7405 191.418 69.7405 192.023C69.7405 192.628 70.2311 193.118 70.8364 193.118Z",
    fill: "#1E2243"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.567 192.388C71.7687 192.388 71.9323 192.225 71.9323 192.023C71.9323 191.822 71.7687 191.658 71.567 191.658C71.3652 191.658 71.2017 191.822 71.2017 192.023C71.2017 192.225 71.3652 192.388 71.567 192.388Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7952 192.388C81.997 192.388 82.1605 192.225 82.1605 192.023C82.1605 191.822 81.997 191.658 81.7952 191.658C81.5935 191.658 81.4299 191.822 81.4299 192.023C81.4299 192.225 81.5935 192.388 81.7952 192.388Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2576 195.539C77.2576 195.539 79.7214 199.683 77.8781 199.978",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3654 203.822C79.3654 203.822 74.1072 203.706 72.3508 203.321C72.3508 203.321 74.2352 206.307 76.5082 206.307C78.7812 206.307 79.3654 203.822 79.3654 203.822Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4008 199.839C55.8131 199.839 56.9579 198.695 56.9579 197.283C56.9579 195.872 55.8131 194.728 54.4008 194.728C52.9886 194.728 51.8438 195.872 51.8438 197.283C51.8438 198.695 52.9886 199.839 54.4008 199.839Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6472 545.638C40.6472 545.638 48.2703 563.083 54.9452 569.971C61.6202 576.86 68.5449 582.584 61.7451 584.616C54.9452 586.648 31.7853 573.931 29.5098 565.127C27.2343 556.323 27.032 544.106 27.032 544.106L40.6472 545.638Z",
    fill: "#131C5D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3409 317.732L72.6094 355.898L100.396 430.637",
    stroke: "white",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5982 308.732L47.6625 554.33H26.0705C26.0705 554.33 15.2025 480.087 22.9513 454.067C30.7002 428.047 19.8322 411.969 26.0705 382.072C32.3089 352.175 15.1837 341.865 32.3089 310.501C49.4341 279.138 71.5982 308.732 71.5982 308.732Z",
    fill: "#3542A7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.359 545.638C117.359 545.638 124.982 563.083 131.657 569.971C138.332 576.86 145.257 582.584 138.457 584.616C131.657 586.648 108.497 573.931 106.222 565.127C103.946 556.323 103.744 544.106 103.744 544.106L117.359 545.638Z",
    fill: "#131C5D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5652 302.742L124.932 555.06H103.431C103.431 555.06 77.1258 484.748 79.3717 457.685C81.6176 430.621 67.475 417.178 67.4118 386.64C67.3487 356.102 48.2052 349.61 58.6348 315.356C69.0643 281.103 92.5652 302.742 92.5652 302.742Z",
    fill: "#3542A7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.071 381.032C143.071 381.032 144.693 386.745 144.262 388.851C143.262 393.745 145.206 395.786 143.071 398.192C139.983 401.672 140.35 404.671 142.579 403.683C145.263 402.495 145.263 401.362 147.454 398.82C147.454 398.82 147.536 402.532 146.931 403.808C146.438 404.848 144.891 405.602 144.262 406.144C141.692 408.358 143.671 409.508 148.05 406.827C146.454 409.318 144.262 410.826 145.263 411.549C146.435 412.395 151.081 407.775 151.081 407.775C151.081 407.775 147.645 412.751 148.646 413.833C149.646 414.915 154.696 408.43 154.696 408.43C154.696 408.43 154.884 409.941 154.262 411.549C153.641 413.157 152.954 414.192 153.835 414.571C155.371 414.571 159.09 412.695 159.09 403.808C159.09 394.921 151.081 372.947 151.081 372.947L143.071 381.032Z",
    fill: "#FB6464"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.454 407.34C147.454 407.34 148.542 406.366 149.094 403.606",
    stroke: "white",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.454 399.536C148.581 397.701 151.509 394.407 151.509 394.407C151.509 394.407 155.858 406.723 154.331 409.845",
    stroke: "white",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.242 408.517C150.242 408.517 152.182 407.216 151.509 400.487",
    stroke: "white",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7801 233.904C99.7801 233.904 106.14 235.485 108.713 239.192C114.428 247.426 118.691 264.104 123.196 285.662C132.997 332.558 146.906 347.53 153.453 369.795C154.222 372.741 151.026 373.847 153.453 378.627C153.874 381.039 143.036 383.185 141.988 381.45C139.199 375.764 137.747 379.37 136.438 377.232C122.802 351.36 112.998 338.086 110.563 319.579C108.128 301.071 90.2734 277.029 90.2734 277.029L99.7801 233.904Z",
    fill: "#F5A623"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 233,
    width: 64,
    height: 150
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7801 233.904C99.7801 233.904 106.14 235.485 108.713 239.192C114.428 247.426 118.691 264.104 123.196 285.662C132.997 332.558 146.906 347.53 153.453 369.795C154.222 372.741 151.026 373.847 153.453 378.627C153.874 381.039 143.036 383.185 141.988 381.45C139.199 375.764 137.747 379.37 136.438 377.232C122.802 351.36 112.998 338.086 110.563 319.579C108.128 301.071 90.2734 277.029 90.2734 277.029L99.7801 233.904Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.071 377.809L144.262 382.08",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.263 377.078L146.454 382.08",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.455 376.348L148.646 381.35",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.646 375.618L150.837 380.62",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.827 314.081L112.082 307.144",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7481 248.49C92.7481 248.49 106.328 263.675 106.667 277.789C106.838 284.929 106.671 293.629 107.675 301.165C112.157 334.81 118.327 347.308 118.327 347.308L88.8123 289.288L96.5619 231.02L92.7481 248.49Z",
    fill: "#D69321"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.724 228.872C51.724 228.872 49.6654 224.124 51.724 221.88C51.724 221.88 49.833 217.244 51.724 215.024C53.615 212.804 75.1529 215.024 79.0003 215.024C82.8477 215.024 79.6304 221.88 79.6304 221.88C79.6304 221.88 83.2788 223.434 80.7748 227.984L101.965 234.437C103.842 240.227 105.063 255.01 105.936 266.041C106.714 275.86 107.551 281.81 100.712 285.16C100.712 285.16 97.4224 307.695 90.2733 307.992C83.1241 308.289 36.4558 310.429 36.4558 310.429L42.6222 289.992L27.032 240.567L51.724 228.872Z",
    fill: "#F5A623"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 214,
    width: 80,
    height: 97
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.724 228.872C51.724 228.872 49.6654 224.124 51.724 221.88C51.724 221.88 49.833 217.244 51.724 215.024C53.615 212.804 75.1529 215.024 79.0003 215.024C82.8477 215.024 79.6304 221.88 79.6304 221.88C79.6304 221.88 83.2788 223.434 80.7748 227.984L101.965 234.437C103.842 240.227 105.063 255.01 105.936 266.041C106.714 275.86 107.551 281.81 100.712 285.16C100.712 285.16 97.4224 307.695 90.2733 307.992C83.1241 308.289 36.4558 310.429 36.4558 310.429L42.6222 289.992L27.032 240.567L51.724 228.872Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5842 270.997L75.6827 310.364H58.4475L94.5842 270.997Z",
    fill: "#D69321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4109 229.008H70.7984",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7991 221.705H56.1865",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0229 221.705H85.4104",
    stroke: "white",
    strokeLinecap: "round"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.962 257.879C104.576 274.346 112.955 283.212 92.0227 287.554",
    stroke: "white",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.84 217.689C105.446 217.689 105.936 217.198 105.936 216.593C105.936 215.988 105.446 215.498 104.84 215.498C104.235 215.498 103.744 215.988 103.744 216.593C103.744 217.198 104.235 217.689 104.84 217.689Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3655 265.231L90.2702 275.593C90.2702 275.593 101.895 263.625 109.639 254.89C114.948 248.902 112.554 240.991 114.403 233.904C115.251 230.654 122.722 225.949 122.054 224.575C121.047 222.5 116.844 226.331 109.955 231.02C107.165 232.918 100.396 235.854 100.396 235.854C100.396 235.854 96.0045 233.211 94.0171 241.046C92.0296 248.881 80.3655 265.231 80.3655 265.231Z",
    fill: "#FB6464"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M115.429 233.211L108.939 238.497",
    stroke: "white",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21017 301.666C9.23638 301.666 11.6896 299.214 11.6896 296.19C11.6896 293.165 9.23638 290.713 6.21017 290.713C3.18395 290.713 0.730713 293.165 0.730713 296.19C0.730713 299.214 3.18395 301.666 6.21017 301.666Z",
    stroke: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19478 308.969C11.221 308.969 13.6742 306.517 13.6742 303.492C13.6742 300.467 11.221 298.015 8.19478 298.015C5.16857 298.015 2.71533 300.467 2.71533 303.492C2.71533 306.517 5.16857 308.969 8.19478 308.969Z",
    stroke: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1318 240.017C28.1318 240.017 13.6741 247.76 13.6741 269.35C14.6551 284.311 20.5703 288.769 33.2816 316.673C43.7547 339.663 86.1448 293.135 87.9516 279.756C90.7517 275.524 93.9453 273.219 94.5842 271.538L81.8645 259.323C81.8645 259.323 65.3612 269.181 57.1822 275.593C49.0032 282.005 44.729 288.434 44.729 288.434C44.729 288.434 47.3759 289.24 43.0956 276.753C38.8152 264.267 28.1318 240.017 28.1318 240.017Z",
    fill: "#F5A623"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2135 260.701L79.3655 265.085",
    stroke: "white",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4052 262.891L81.5571 267.275",
    stroke: "white",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5971 265.082L83.749 269.466",
    stroke: "white",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7887 268.003L85.9407 272.387",
    stroke: "white",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9806 270.193L88.1326 274.578",
    stroke: "white",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 251.545C40.502 266.754 45.993 286.639 45.993 286.639C45.993 286.639 68.0523 263.873 73.3436 263.873C78.6349 263.873 81.8646 259.323 81.8646 259.323",
    stroke: "white",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.698 238.781L111 242.296",
    stroke: "white",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M113.965 243.989L111.919 245.684",
    stroke: "white",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9929 286.639L41.2817 301.425",
    stroke: "white",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M100.172 229.429C100.172 229.429 110.482 212.022 123.243 209.955C136.004 207.887 140.164 219.917 156.33 217.816C172.497 215.715 197 188.337 197 188.337",
    stroke: "#131C5D",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.429548,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.21 189.688C196.627 186.682 194.292 184 191.257 184H115.415C112.919 184 110.806 185.84 110.462 188.312L103.515 238.312C103.097 241.318 105.432 244 108.467 244H184.309C186.805 244 188.918 242.16 189.262 239.688L196.21 189.688Z",
    fill: "#DCDCDC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.269 220.59C125.081 218.583 124.717 213.377 127.457 208.961C130.196 204.545 135.001 202.592 138.189 204.598C141.377 206.605 141.741 211.812 139.002 216.228C136.263 220.644 131.457 222.597 128.269 220.59Z",
    fill: "#01D1B2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.666 551.481L862.26 546.613C865.476 538.715 871.073 533.422 879.051 530.733C893.345 525.915 905.517 544.143 911.957 540.265C918.398 536.387 919.985 530.233 921.67 524.614L937.051 528.266L923.927 518.127C930.107 502.723 940.183 493.908 954.156 491.683C966.133 489.776 981.236 491.683 988.316 499.687L984.763 518.127L999.322 505.419C1003.95 510.449 1006.59 515.784 1015.5 518.127C1024.4 520.469 1028.12 514.582 1036.72 513.65L1037.62 528.266L1042.84 513.477C1055.04 514.149 1066.97 521.127 1076.41 538.255L1067.89 546.613L1080.26 546.15C1083.19 552.923 1085.8 560.912 1088 570.266H859.096C858.765 563.071 859.287 556.81 860.662 551.481H871.666Z",
    fill: "#B9CFFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M915.701 537.973L973.866 570.191",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M973.866 570.266L948.259 491.734",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M890.012 570.553L874.404 531.093",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.81 570.19L1066.33 524.327",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M970.208 560.725L1008.98 515.22",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M956.307 515.22L931.431 504.945",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M887.534 562.926L859 560.725",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 561.459L1085.07 557.789",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.033 541.537L957.593 223.664C959.111 212.835 950.702 203.165 939.768 203.165H533.435C516.789 203.165 502.446 214.889 499.134 231.202L436.131 541.537H913.033Z",
    fill: "#83A3E7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.157 541.537L943.717 223.664C945.235 212.835 936.826 203.165 925.891 203.165H519.559C502.913 203.165 488.57 214.889 485.258 231.202L422.255 541.537H899.157Z",
    fill: "white",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M885.842 518.912L921.798 223.331H503.998L448.547 518.912H885.842Z",
    fill: "white",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1034.99 284.886C1035.53 280.702 1032.27 277 1028.05 277H850.132C846.609 277 843.635 279.619 843.189 283.114L836.593 334.798C836.059 338.982 839.318 342.685 843.536 342.685H1021.45C1024.98 342.685 1027.95 340.066 1028.4 336.571L1034.99 284.886Z",
    fill: "#7988FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.387 324.504C867.441 324.504 860.999 318.071 860.999 310.136C860.999 302.2 867.441 295.767 875.387 295.767C883.333 295.767 889.775 302.2 889.775 310.136C889.775 318.071 883.333 324.504 875.387 324.504Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M948.656 300.853H906.19",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.22 312.009H904.752",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M987.792 323.282H902.937",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.644 286.231C608.423 280.929 612.971 277 618.33 277H818.498C825.088 277 830.141 282.85 829.184 289.369L811.356 410.769C810.577 416.071 806.029 420 800.67 420H600.502C593.913 420 588.859 414.15 589.817 407.631L607.644 286.231Z",
    fill: "#F5D123"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759.176 392.364C758.458 392.364 757.908 391.726 758.013 391.016L770.126 309.004C770.212 308.427 770.707 308 771.29 308H780.642C781.36 308 781.91 308.637 781.805 309.348L769.692 391.36C769.606 391.936 769.111 392.364 768.528 392.364H759.176Z",
    fill: "#C1DEFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759.176 392.364C758.458 392.364 757.908 391.726 758.013 391.016L766.186 335.788C766.272 335.211 766.767 334.784 767.35 334.784H776.702C777.42 334.784 777.97 335.422 777.865 336.132L769.692 391.36C769.606 391.937 769.111 392.364 768.528 392.364H759.176Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.176 392.364C733.458 392.364 732.908 391.726 733.013 391.016L745.126 309.004C745.212 308.427 745.707 308 746.29 308H755.642C756.36 308 756.91 308.637 756.805 309.348L744.692 391.36C744.606 391.936 744.111 392.364 743.528 392.364H734.176Z",
    fill: "#C1DEFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.176 392.364C708.458 392.364 707.908 391.726 708.013 391.016L720.126 309.004C720.212 308.427 720.707 308 721.29 308H730.642C731.36 308 731.91 308.637 731.805 309.348L719.692 391.36C719.606 391.936 719.111 392.364 718.528 392.364H709.176Z",
    fill: "#C1DEFF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.176 392.364C683.458 392.364 682.908 391.726 683.013 391.016L695.126 309.004C695.212 308.427 695.707 308 696.29 308H705.642C706.36 308 706.91 308.637 706.805 309.348L694.692 391.36C694.606 391.936 694.111 392.364 693.528 392.364H684.176Z",
    fill: "#C1DEFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.176 392.364C658.458 392.364 657.908 391.726 658.013 391.016L670.126 309.004C670.212 308.427 670.707 308 671.29 308H680.642C681.36 308 681.91 308.637 681.805 309.348L669.692 391.36C669.606 391.936 669.111 392.364 668.528 392.364H659.176Z",
    fill: "#C1DEFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.176 392.364C633.458 392.364 632.908 391.726 633.013 391.016L645.126 309.004C645.212 308.427 645.707 308 646.29 308H655.642C656.36 308 656.91 308.637 656.805 309.348L644.692 391.36C644.606 391.936 644.111 392.364 643.528 392.364H634.176Z",
    fill: "#C1DEFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.174 392.364C733.457 392.364 732.906 391.727 733.01 391.018L739.374 347.454C739.458 346.876 739.954 346.448 740.538 346.448H749.89C750.607 346.448 751.158 347.084 751.054 347.794L744.69 391.358C744.606 391.935 744.11 392.364 743.527 392.364H734.174Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.176 392.364C708.458 392.364 707.908 391.726 708.013 391.016L717.126 329.399C717.212 328.823 717.707 328.395 718.29 328.395H727.642C728.36 328.395 728.91 329.033 728.805 329.744L719.692 391.36C719.606 391.937 719.111 392.364 718.528 392.364H709.176Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.176 392.364C683.458 392.364 682.907 391.726 683.012 391.016L693.017 323.096C693.102 322.518 693.597 322.091 694.181 322.091H703.533C704.251 322.091 704.801 322.728 704.697 323.438L694.691 391.359C694.606 391.936 694.111 392.364 693.528 392.364H684.176Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.177 392.364C658.459 392.364 657.908 391.726 658.013 391.015L664.985 344.021C665.071 343.444 665.566 343.017 666.148 343.017H675.5C676.219 343.017 676.769 343.656 676.664 344.366L669.692 391.36C669.606 391.937 669.112 392.364 668.529 392.364H659.177Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.177 392.364C633.459 392.364 632.908 391.726 633.013 391.015L643.818 318.18C643.904 317.604 644.399 317.177 644.981 317.177H654.333C655.052 317.177 655.602 317.815 655.497 318.525L644.692 391.36C644.606 391.937 644.112 392.364 643.529 392.364H634.177Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1025.99 361.886C1026.53 357.702 1023.27 354 1019.05 354H841.132C837.609 354 834.635 356.619 834.189 360.114L827.593 411.798C827.059 415.982 830.318 419.685 834.536 419.685H1012.45C1015.98 419.685 1018.95 417.066 1019.4 413.571L1025.99 361.886Z",
    fill: "#01D1B2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M866.387 401.504C858.441 401.504 851.999 395.071 851.999 387.136C851.999 379.2 858.441 372.767 866.387 372.767C874.333 372.767 880.775 379.2 880.775 387.136C880.775 395.071 874.333 401.504 866.387 401.504Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M940.386 377.853H897.92",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M998.225 389.009H895.752",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M978.792 400.282H893.937",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M611.736 541.537H914.091V551C914.091 561.493 905.585 570 895.091 570H611.736V541.537Z",
    fill: "#131C5D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M240 541.537H648.252V544C648.252 558.359 636.612 570 622.252 570H268C252.536 570 240 557.464 240 542V541.537Z",
    fill: "#83A3E7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.329 347.42C246.329 341.487 242.802 339.169 239.831 338.496C238.176 333.246 234.159 327.904 221.981 330.046C209.803 332.188 199.988 342.915 197.78 352.903C195.572 362.892 197.25 373.253 192 385.647H250C245.774 370.765 246.329 353.353 246.329 347.42Z",
    fill: "#131C5D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.456 336.114C217.335 336.114 222.101 331.387 222.101 325.557C222.101 319.727 217.335 315 211.456 315C205.576 315 200.81 319.727 200.81 325.557C200.81 331.387 205.576 336.114 211.456 336.114Z",
    fill: "#131C5D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.106 367.175V397.771H233.866V375.867L211.106 367.175Z",
    fill: "#F8A08D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.866 382.473C233.866 382.473 224.321 383.212 214.777 377.259C219.954 385.314 233.866 395.495 233.866 395.495V382.473Z",
    fill: "#E08F7D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.631 353.428C240.631 353.428 241.958 369.551 240.631 376.012C239.304 382.473 234.187 383.212 229.983 383.212C225.78 383.212 211.106 383.351 211.106 367.175C211.106 367.175 206.456 366.622 206.456 361.64C206.456 356.659 211.237 359.066 215.322 359.066C219.407 359.066 230.241 357.994 234.211 345.617C234.211 345.617 235.372 349.735 237.181 351.611C238.849 353.342 240.631 353.428 240.631 353.428Z",
    fill: "#F8A08D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M220.293 356.825C220.787 356.783 223.432 355.031 227.833 356.527",
    stroke: "#1E2243",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M235.148 356.5C235.583 356.5 238.027 354.984 241.756 356.854",
    stroke: "#1E2243",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.858 362.002C238.466 362.002 238.959 361.513 238.959 360.909C238.959 360.306 238.466 359.817 237.858 359.817C237.249 359.817 236.756 360.306 236.756 360.909C236.756 361.513 237.249 362.002 237.858 362.002Z",
    fill: "#1E2243"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.579 362.002C228.187 362.002 228.68 361.513 228.68 360.909C228.68 360.306 228.187 359.817 227.579 359.817C226.971 359.817 226.478 360.306 226.478 360.909C226.478 361.513 226.971 362.002 227.579 362.002Z",
    fill: "#1E2243"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.313 361.273C228.516 361.273 228.68 361.11 228.68 360.909C228.68 360.708 228.516 360.545 228.313 360.545C228.111 360.545 227.946 360.708 227.946 360.909C227.946 361.11 228.111 361.273 228.313 361.273Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.592 361.273C238.794 361.273 238.959 361.11 238.959 360.909C238.959 360.708 238.794 360.545 238.592 360.545C238.389 360.545 238.225 360.708 238.225 360.909C238.225 361.11 238.389 361.273 238.592 361.273Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M234.032 364.415C234.032 364.415 236.508 368.547 234.655 368.841",
    stroke: "#1E2243",
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.15 372.673C236.15 372.673 230.866 372.558 229.101 372.174C229.101 372.174 230.995 375.151 233.279 375.151C235.563 375.151 236.15 372.673 236.15 372.673Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.693 367.098C242.937 367.098 245.566 364.49 245.566 361.273C245.566 358.056 242.937 355.449 239.693 355.449C236.449 355.449 233.82 358.056 233.82 361.273C233.82 364.49 236.449 367.098 239.693 367.098Z",
    stroke: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.009 367.098C228.253 367.098 230.883 364.49 230.883 361.273C230.883 358.056 228.253 355.449 225.009 355.449C221.766 355.449 219.136 358.056 219.136 361.273C219.136 364.49 221.766 367.098 225.009 367.098Z",
    stroke: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M230.492 359.575C230.492 359.575 232.295 357.876 234.032 359.575",
    stroke: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M219.136 359.453L211.06 358.361",
    stroke: "white",
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.987 371.789C211.407 371.789 212.557 370.648 212.557 369.241C212.557 367.834 211.407 366.693 209.987 366.693C208.568 366.693 207.418 367.834 207.418 369.241C207.418 370.648 208.568 371.789 209.987 371.789Z",
    stroke: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.624 399.317C207.624 399.317 205.562 394.562 207.624 392.315C207.624 392.315 205.73 387.672 207.624 385.448C209.517 383.225 231.083 385.448 234.935 385.448C238.788 385.448 235.566 392.315 235.566 392.315C235.566 392.315 239.219 393.871 236.712 398.428L257.93 404.89C259.809 410.689 261.031 425.495 261.906 436.543C262.685 446.376 263.523 452.335 256.676 455.69C256.676 455.69 255.133 480.701 247.975 480.998C240.816 481.295 192.335 480.998 192.335 480.998L198.51 460.53L182.899 411.03L207.624 399.317Z",
    fill: "#01D1B2"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 384,
    width: 81,
    height: 98
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.624 399.317C207.624 399.317 205.562 394.562 207.624 392.315C207.624 392.315 205.73 387.672 207.624 385.448C209.517 383.225 231.083 385.448 234.935 385.448C238.788 385.448 235.566 392.315 235.566 392.315C235.566 392.315 239.219 393.871 236.712 398.428L257.93 404.89C259.809 410.689 261.031 425.495 261.906 436.543C262.685 446.376 263.523 452.335 256.676 455.69C256.676 455.69 255.133 480.701 247.975 480.998C240.816 481.295 192.335 480.998 192.335 480.998L198.51 460.53L182.899 411.03L207.624 399.317Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.336 479.501C195.336 479.501 223.983 471.861 227.856 465.761C229.539 463.335 233.688 462.858 233.688 462.858C233.688 462.858 236.818 465.498 242.81 464.595C248.802 463.692 242.81 474.94 242.81 474.94L195.336 479.501Z",
    fill: "#10BBA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.309 399.453H226.723",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.678 392.14H212.092",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.94 392.14H241.354",
    stroke: "white",
    strokeLinecap: "round"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M258.928 428.368C260.544 444.859 268.935 453.739 247.975 458.088",
    stroke: "white",
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.825 386.68C308.825 386.68 309.544 370.165 311.373 367.392C313.203 364.619 318.159 363.25 318.159 363.25C318.159 363.25 326.699 345.378 329.053 347.162C331.408 348.945 325.764 358.215 325.764 360.733C325.764 363.25 332.976 368.422 331.489 373.908C330.003 379.395 322.291 383.88 321.154 388.999C320.018 394.119 308.825 386.68 308.825 386.68Z",
    fill: "#F8A08D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M325.764 360.733L321.912 364.619",
    stroke: "white",
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M327.808 364.619L324.57 366.583",
    stroke: "white",
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M330.852 368.046C330.852 368.046 323.238 373.034 321.12 373.034C319.002 373.034 321.912 369.775 321.912 369.775",
    stroke: "white",
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M327.968 369.93C327.968 369.93 322.529 375.161 324.741 375.833C326.642 376.411 328.62 373.347 331.849 371.933",
    stroke: "white",
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.501 404.508C256.501 404.508 260.742 405.378 263.369 407.352C268.334 411.083 274.193 418.042 277.681 423.636C285.681 436.469 289.165 441.153 289.165 441.153C289.165 441.153 295.494 399.517 302.118 394.371C308.743 389.225 307.965 385.947 307.965 385.947L322.089 389.225C322.089 389.225 319.673 396.307 322.089 400.994C324.506 405.682 323.354 431.06 316.048 453.011C308.743 474.962 298.868 486.16 266.669 469.631C234.47 453.103 235.67 434.424 235.67 434.424L256.501 404.508Z",
    fill: "#01D1B2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.886 450.281C264.872 450.281 272.019 464.325 272.019 464.325C272.019 464.325 266.089 462.993 261.444 457.303C261.444 457.303 265.707 466.552 263.576 466.552C261.444 466.552 256.46 457.861 256.46 457.861C256.46 457.861 260.649 466.552 257.886 466.552C255.124 466.552 252.396 458.416 252.396 458.416C252.396 458.416 253.787 468.778 250.901 466.552C248.014 464.325 244.686 464.325 239.924 464.325C235.161 464.325 233.041 461.509 233.041 461.509L226.81 462.444L225.585 452.808C225.585 452.808 250.901 450.281 257.886 450.281Z",
    fill: "#F8A08D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.895 419.84C247.152 418.411 248.395 417.371 249.848 417.371H324.221C326.09 417.371 327.504 419.061 327.174 420.901L317.215 476.334C316.959 477.763 315.715 478.803 314.263 478.803H239.889C238.02 478.803 236.606 477.113 236.936 475.273L246.895 419.84Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.09 419.84C249.346 418.411 250.59 417.371 252.042 417.371H326.416C328.285 417.371 329.699 419.061 329.369 420.901L319.41 476.334C319.153 477.763 317.91 478.803 316.458 478.803H242.084C240.215 478.803 238.801 477.113 239.131 475.273L249.09 419.84Z",
    fill: "#131C5D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.681 452.475C287.499 452.475 288.973 451.002 288.973 449.184C288.973 447.367 287.499 445.893 285.681 445.893C283.863 445.893 282.389 447.367 282.389 449.184C282.389 451.002 283.863 452.475 285.681 452.475Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.27 509.595C298.27 509.595 371.476 530.48 361.168 557.789C355.364 573.164 346.46 577.044 314.247 574.714C288.887 572.879 210.459 560.143 210.459 560.143L225.323 509.168L298.27 509.595Z",
    fill: "#3542A7"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 509,
    width: 153,
    height: 67
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.27 509.595C298.27 509.595 371.476 530.48 361.168 557.789C355.364 573.164 346.46 577.044 314.247 574.714C288.887 572.879 210.459 560.143 210.459 560.143L225.323 509.168L298.27 509.595Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.78 565.896L278.303 552.507L276.551 567.778L320.149 500.718L285.92 493.181L225.78 565.896Z",
    fill: "#283593"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.817 573.042C278.817 573.042 335.803 525.97 339.472 520.856C343.14 515.742 361.128 533.608 364.513 540.056L278.817 573.042Z",
    fill: "#283593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.302 546.495L327.382 549.767",
    stroke: "white",
    strokeLinecap: "round"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.369 558.449C263.369 558.449 241.347 576.08 244.229 584.067C247.111 592.055 278.909 589.516 289.165 589.516C299.421 589.516 292.527 584.067 282.055 579.606C271.584 575.145 272.964 573.041 276.642 567.778C280.32 562.515 276.642 555.343 276.642 555.343L263.369 558.449Z",
    fill: "#131C5D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M275.891 576.052L262.638 572.416",
    stroke: "white",
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.816 558.956C202.816 558.956 186.54 573.447 188.375 578.227C190.21 583.006 215.879 562.188 228.599 562.79C241.318 563.393 202.816 558.956 202.816 558.956Z",
    fill: "#131C5D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.11 481.025C194.11 481.025 186.726 498.329 187.335 528.058C187.944 557.786 217.634 583.698 262.803 547.209C307.972 510.72 308.203 512.277 308.203 512.277L258.494 560.341L277.216 572.415C277.216 572.415 372.972 505.192 353.838 478.804C342.387 463.012 325.652 466.913 297.288 475.346C286.797 478.465 257.599 487.299 257.599 487.299L254.96 478.804L194.11 481.025Z",
    fill: "#3542A7"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 467,
    width: 170,
    height: 106
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.11 481.025C194.11 481.025 186.726 498.329 187.335 528.058C187.944 557.786 217.634 583.698 262.803 547.209C307.972 510.72 308.203 512.277 308.203 512.277L258.494 560.341L277.216 572.415C277.216 572.415 372.972 505.192 353.838 478.804C342.387 463.012 325.652 466.913 297.288 475.346C286.797 478.465 257.599 487.299 257.599 487.299L254.96 478.804L194.11 481.025Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.443 484.654C260.443 484.654 223.283 506.595 221.671 484.654",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.612 480.998C196.612 480.998 192.28 496.279 202.651 499.281",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.417 478.804C206.417 478.804 192.985 545.152 214.058 552.903C235.131 560.654 306.99 500.665 318.432 502.987C329.873 505.308 263.369 562.908 263.369 562.908",
    stroke: "white",
    strokeLinecap: "round"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.644 478.804H285.681L269.873 483.674L234.644 483.923V478.804Z",
    fill: "#131C5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192.129,
    y: 478.554,
    width: 47.5503,
    height: 5.1194,
    rx: 2.5597,
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.35 410.602C183.35 410.602 174.28 416.236 166.147 431.066C158.015 445.897 147.681 466.172 152.029 477.194C156.378 488.217 188.327 482.7 203.59 476.398C218.854 470.096 224.892 470.842 227.452 467.584C230.012 464.327 233.688 462.858 233.688 462.858L230.48 452.175C230.48 452.175 226.894 451.828 222.659 450.933C218.424 450.038 209.167 444.935 190.417 450.933C190.417 450.933 197.369 440.244 196.352 427.623C195.336 415.003 183.35 410.602 183.35 410.602Z",
    fill: "#01D1B2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M176.197 459.66C181.511 455.679 186.66 452.788 191.508 450.736C198.319 447.482 221.707 446.626 225.519 449.184C226.672 451.555 230.453 452.475 230.453 452.475",
    stroke: "white",
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M193.411 445.893C193.411 445.893 195.588 430.961 190.135 417.371",
    stroke: "white",
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M318.159 363.25C318.159 363.25 324.741 366.157 324.741 368.182C324.741 370.206 319.858 368.729 318.159 369.468C316.459 370.206 319.131 379.538 319.131 379.538",
    stroke: "white",
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.884 328.473C459.884 336.53 456.522 343.062 452.375 343.062C448.227 343.062 444.866 336.53 444.866 328.473C444.866 320.414 448.227 313.882 452.375 313.882C456.522 313.882 459.884 320.414 459.884 328.473Z",
    fill: "#005AC6"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.012 328.473C579.012 336.53 575.65 343.062 571.503 343.062C567.356 343.062 563.994 336.53 563.994 328.473C563.994 320.414 567.356 313.882 571.503 313.882C575.65 313.882 579.012 320.414 579.012 328.473Z",
    fill: "#005AC6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473 344.577C473 347.695 470.476 350.223 467.364 350.223H456.092C452.979 350.223 450.455 347.695 450.455 344.577V311.642C450.455 308.524 452.979 305.996 456.092 305.996H467.364C470.476 305.996 473 308.524 473 311.642V344.577Z",
    fill: "#1F83FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.422 344.577C573.422 347.695 570.899 350.223 567.786 350.223H556.514C553.401 350.223 550.877 347.695 550.877 344.577V311.642C550.877 308.524 553.401 305.996 556.514 305.996H567.786C570.899 305.996 573.422 308.524 573.422 311.642V344.577Z",
    fill: "#1F83FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.766 497.599H538.653C538.651 504.998 535.668 511.668 530.828 516.521C525.985 521.37 519.325 524.358 511.938 524.36C504.553 524.358 497.892 521.37 493.05 516.521C488.21 511.668 485.227 504.998 485.225 497.599V469.917C485.201 462.502 488.321 453.673 493.343 446.959C495.843 443.597 498.798 440.76 501.962 438.809C505.134 436.85 508.483 435.772 511.938 435.769C515.395 435.772 518.741 436.85 521.916 438.809C526.667 441.732 530.926 446.668 533.922 452.338C536.931 457.994 538.664 464.36 538.653 469.917V497.599H544.878V469.917C544.855 460.831 541.299 451.028 535.525 443.234C532.628 439.341 529.155 435.956 525.184 433.501C521.218 431.048 516.718 429.533 511.938 429.533C507.16 429.533 502.66 431.048 498.694 433.501C492.741 437.19 487.893 442.945 484.457 449.412C481.033 455.889 479.007 463.1 479 469.917V497.599C479.002 515.823 493.745 530.593 511.938 530.596C530.133 530.593 544.876 515.823 544.878 497.599H541.766Z",
    fill: "#1F83FF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.201 534.213C521.977 534.213 525.039 531.152 525.039 527.376V522.655C525.039 518.878 521.977 515.817 518.201 515.817V534.213Z",
    fill: "#005AC6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.839 527.376C498.839 531.152 501.9 534.213 505.676 534.213V515.817C501.9 515.817 498.839 518.878 498.839 522.655V527.376Z",
    fill: "#005AC6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.192 540.81H506.685C504.506 540.81 502.743 539.043 502.743 536.861V513.17C502.743 510.99 504.506 509.221 506.685 509.221H517.192C519.371 509.221 521.135 510.99 521.135 513.17V536.861C521.135 539.043 519.371 540.81 517.192 540.81Z",
    fill: "#21385B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.052 483.028C510.052 488.466 505.653 492.873 500.227 492.873H483.116C477.69 492.873 473.291 488.466 473.291 483.028V462.725C473.291 457.29 477.69 452.881 483.116 452.881H500.227C505.653 452.881 510.052 457.29 510.052 462.725V483.028Z",
    fill: "#005AC6"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.587 483.028C550.587 488.466 546.188 492.873 540.762 492.873H523.653C518.225 492.873 513.826 488.466 513.826 483.028V462.725C513.826 457.29 518.225 452.881 523.653 452.881H540.762C546.188 452.881 550.587 457.29 550.587 462.725V483.028Z",
    fill: "#005AC6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.494 412.905C465.105 412.962 456.449 413.908 447.55 420.492C443.112 423.784 438.651 428.528 435.352 435.166C432.045 441.802 429.923 450.288 429.928 460.961C429.928 468.603 431.005 477.372 433.489 487.468L441.045 485.603C438.685 476.015 437.707 467.865 437.709 460.961C437.712 451.306 439.603 444.102 442.316 438.643C446.388 430.477 452.385 426.041 457.471 423.539C460.005 422.297 462.296 421.562 463.919 421.149C464.729 420.941 465.374 420.811 465.795 420.738L466.256 420.666L466.347 420.653L466.3 420.266L466.342 420.653H466.347L466.3 420.266L466.342 420.653L465.494 412.905Z",
    fill: "#1F83FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.712 513.879C440.399 514.098 439.157 513.209 438.939 511.894L436.496 494.042C436.278 492.725 437.165 491.483 438.48 491.264C439.792 491.046 441.035 491.935 441.253 493.249L443.696 511.102C443.914 512.419 443.027 513.661 441.712 513.879Z",
    fill: "url(#paint0_linear)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.018 519.759C448.11 520.733 446.585 520.788 445.613 519.878L439.969 514.594C438.993 513.684 438.942 512.156 439.849 511.182C440.755 510.205 442.282 510.151 443.255 511.06L448.899 516.345C449.874 517.254 449.926 518.782 449.018 519.759Z",
    fill: "url(#paint1_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.106 512.544C443.854 514.066 442.417 515.095 440.897 514.843C439.38 514.591 438.35 513.154 438.602 511.632C438.853 510.109 440.29 509.078 441.808 509.33C443.328 509.582 444.357 511.021 444.106 512.544Z",
    fill: "#005AC6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.648 508.81C452.598 509.628 451.083 509.439 450.269 508.384L439.642 493.844C438.825 492.792 439.017 491.275 440.067 490.456C441.12 489.638 442.633 489.83 443.45 490.882L454.076 505.425C454.891 506.477 454.701 507.994 453.648 508.81Z",
    fill: "url(#paint2_linear)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.524 510.566C462.075 511.821 460.698 512.476 459.443 512.029L452.172 509.415C450.917 508.968 450.263 507.586 450.712 506.331C451.158 505.074 452.538 504.419 453.791 504.868L461.064 507.48C462.319 507.929 462.973 509.311 462.524 510.566Z",
    fill: "url(#paint3_linear)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.997 507.225C454.916 508.766 453.604 509.948 452.063 509.868C450.525 509.787 449.345 508.472 449.426 506.932C449.509 505.391 450.821 504.206 452.359 504.289C453.897 504.37 455.077 505.685 454.997 507.225Z",
    fill: "#005AC6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.16 486.712C455.212 488.175 454.071 489.401 452.611 489.453L440.978 489.864C439.517 489.916 438.29 488.77 438.241 487.31C438.189 485.847 439.331 484.618 440.791 484.566L452.424 484.156C453.884 484.104 455.111 485.249 455.16 486.712Z",
    fill: "url(#paint4_linear)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.485 490.513C461.956 491.88 460.426 492.558 459.061 492.028L452.836 489.469C451.475 488.941 450.798 487.406 451.324 486.042C451.851 484.678 453.384 484 454.745 484.527L460.973 487.086C462.335 487.614 463.012 489.149 462.485 490.513Z",
    fill: "url(#paint5_linear)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.664 486.465C455.752 488.006 454.577 489.323 453.039 489.412C451.501 489.5 450.183 488.32 450.095 486.78C450.009 485.239 451.184 483.919 452.722 483.833C454.26 483.745 455.578 484.925 455.664 486.465Z",
    fill: "#005AC6"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.483 493.364C450.263 495.655 449.042 498.144 446.754 498.926L438.719 501.675C436.431 502.457 433.943 501.234 433.165 498.942L429.236 487.409C428.455 485.12 429.677 482.628 431.962 481.846L440 479.099C442.285 478.317 444.772 479.541 445.553 481.83L449.483 493.364Z",
    fill: "url(#paint6_linear)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.198 427.626C476.198 429.983 474.289 431.895 471.937 431.895H465.507C463.154 431.895 461.245 429.983 461.245 427.626V408.425C461.245 406.069 463.154 404.159 465.507 404.159H471.937C474.289 404.159 476.198 406.069 476.198 408.425V427.626Z",
    fill: "#005AC6"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.536 420.653L557.702 419.128L557.52 420.65L557.536 420.653L557.702 419.128L557.52 420.65C557.613 420.647 564.993 421.609 572.027 427.005C575.557 429.705 579.038 433.475 581.689 438.9C584.334 444.328 586.165 451.457 586.168 460.961C586.168 467.865 585.193 476.015 582.832 485.603L590.388 487.468C592.873 477.372 593.949 468.603 593.949 460.961C593.954 450.288 591.833 441.802 588.526 435.166C583.572 425.189 576.026 419.559 569.825 416.537C563.608 413.497 558.682 412.941 558.384 412.905L557.536 420.653Z",
    fill: "#1F83FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.166 513.879C583.478 514.098 584.721 513.209 584.939 511.894L587.382 494.042C587.6 492.725 586.71 491.483 585.398 491.264C584.085 491.046 582.843 491.935 582.625 493.249L580.182 511.102C579.964 512.419 580.851 513.661 582.166 513.879Z",
    fill: "url(#paint7_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.859 519.759C575.767 520.733 577.292 520.788 578.265 519.878L583.909 514.594C584.884 513.684 584.936 512.156 584.028 511.182C583.12 510.205 581.595 510.151 580.623 511.06L574.979 516.345C574.003 517.254 573.952 518.782 574.859 519.759Z",
    fill: "url(#paint8_linear)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.772 512.544C580.023 514.066 581.46 515.095 582.98 514.843C584.498 514.591 585.527 513.154 585.276 511.632C585.024 510.109 583.59 509.078 582.07 509.33C580.55 509.582 579.52 511.021 579.772 512.544Z",
    fill: "#005AC6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.227 508.81C571.28 509.628 572.795 509.439 573.609 508.384L584.236 493.844C585.053 492.792 584.861 491.275 583.81 490.456C582.757 489.638 581.242 489.83 580.428 490.882L569.801 505.425C568.987 506.477 569.176 507.994 570.227 508.81Z",
    fill: "url(#paint9_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.354 510.567C561.8 511.822 563.18 512.476 564.435 512.03L571.705 509.416C572.961 508.969 573.614 507.587 573.166 506.332C572.72 505.074 571.34 504.419 570.084 504.869L562.814 507.48C561.559 507.93 560.905 509.312 561.354 510.567Z",
    fill: "url(#paint10_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.881 507.225C568.961 508.766 570.273 509.948 571.812 509.868C573.35 509.787 574.532 508.472 574.452 506.932C574.369 505.391 573.057 504.206 571.518 504.289C569.98 504.37 568.8 505.685 568.881 507.225Z",
    fill: "#005AC6"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.717 486.712C568.665 488.175 569.807 489.401 571.267 489.453L582.9 489.864C584.36 489.916 585.587 488.77 585.636 487.31C585.688 485.847 584.547 484.618 583.087 484.566L571.454 484.156C569.993 484.104 568.769 485.249 568.717 486.712Z",
    fill: "url(#paint11_linear)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.392 490.513C561.922 491.88 563.452 492.558 564.816 492.028L571.041 489.469C572.403 488.941 573.08 487.406 572.553 486.042C572.024 484.678 570.494 484 569.132 484.527L562.905 487.086C561.543 487.614 560.866 489.149 561.392 490.513Z",
    fill: "url(#paint12_linear)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.214 486.465C568.126 488.006 569.301 489.323 570.839 489.412C572.377 489.5 573.695 488.32 573.783 486.78C573.869 485.239 572.694 483.919 571.155 483.833C569.617 483.745 568.3 484.925 568.214 486.465Z",
    fill: "#005AC6"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.395 493.364C573.614 495.655 574.836 498.144 577.124 498.926L585.159 501.675C587.447 502.457 589.932 501.234 590.712 498.942L594.642 487.409C595.422 485.12 594.201 482.628 591.916 481.846L583.878 479.099C581.59 478.317 579.105 479.541 578.324 481.83L574.395 493.364Z",
    fill: "url(#paint13_linear)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.679 427.626C547.679 429.983 549.588 431.895 551.941 431.895H558.371C560.723 431.895 562.632 429.983 562.632 427.626V408.425C562.632 406.069 560.723 404.159 558.371 404.159H551.941C549.588 404.159 547.679 406.069 547.679 408.425V427.626Z",
    fill: "#005AC6"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.431 412.79H521.446V376.363H502.431V412.79Z",
    fill: "#21385B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.685 418.761C528.685 421.232 526.685 423.235 524.219 423.235H499.659C497.192 423.235 495.192 421.232 495.192 418.761V398.633C495.192 396.162 497.192 394.159 499.659 394.159H524.219C526.685 394.159 528.685 396.162 528.685 398.633V418.761Z",
    fill: "#005AC6"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.768 407.919C556.768 402.629 552.485 398.339 547.205 398.339H476.673C471.389 398.339 467.11 402.629 467.11 407.919V450.379C467.11 475.182 487.18 495.287 511.937 495.287C536.697 495.287 556.768 475.182 556.768 450.379V407.919Z",
    fill: "#78BBFF"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 467,
    y: 398,
    width: 90,
    height: 98
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.768 407.919C556.768 402.629 552.485 398.339 547.205 398.339H476.673C471.389 398.339 467.11 402.629 467.11 407.919V450.379C467.11 475.182 487.18 495.287 511.937 495.287C536.697 495.287 556.768 475.182 556.768 450.379V407.919Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.308 293.47V334.605C549.308 352.603 532.576 362.268 511.937 362.268C491.299 362.268 474.569 352.603 474.569 334.605V293.47C470.585 296.702 467.117 300.428 464.337 304.562V362.72C473.988 377.073 491.691 385.356 511.937 385.356C532.187 385.356 549.889 377.073 559.541 362.72V304.562C556.76 300.428 553.292 296.702 549.308 293.47Z",
    fill: "url(#paint14_linear)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.937 362.268C532.576 362.268 549.308 352.603 549.308 334.605V293.47C539.46 285.483 526.354 280.591 511.937 280.591C497.524 280.591 484.418 285.483 474.569 293.47V334.605C474.569 352.603 491.299 362.268 511.937 362.268Z",
    fill: "#1F83FF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.577 423.332C544.577 429.349 539.706 434.229 533.699 434.229C527.689 434.229 522.818 429.349 522.818 423.332C522.818 417.312 527.689 412.432 533.699 412.432C539.706 412.432 544.577 417.312 544.577 423.332Z",
    fill: "#1F83FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.853 423.332C538.853 426.182 536.544 428.494 533.699 428.494C530.851 428.494 528.545 426.182 528.545 423.332C528.545 420.479 530.851 418.169 533.699 418.169C536.544 418.169 538.853 420.479 538.853 423.332Z",
    fill: "#005AC6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.206 448.617C537.206 450.558 535.634 452.133 533.699 452.133C531.762 452.133 530.19 450.558 530.19 448.617C530.19 446.679 531.762 445.104 533.699 445.104C535.634 445.104 537.206 446.679 537.206 448.617Z",
    fill: "#005AC6"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.206 461.811C537.206 463.752 535.634 465.324 533.699 465.324C531.762 465.324 530.19 463.752 530.19 461.811C530.19 459.87 531.762 458.298 533.699 458.298C535.634 458.298 537.206 459.87 537.206 461.811Z",
    fill: "#005AC6"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.521 419.029C516.521 419.663 516.007 420.175 515.374 420.175H480.444C479.811 420.175 479.3 419.663 479.3 419.029C479.3 418.395 479.811 417.881 480.444 417.881H515.374C516.007 417.881 516.521 418.395 516.521 419.029Z",
    fill: "#005AC6"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.521 427.631C516.521 428.265 516.007 428.78 515.374 428.78H480.444C479.811 428.78 479.3 428.265 479.3 427.631C479.3 427 479.811 426.485 480.444 426.485H515.374C516.007 426.485 516.521 427 516.521 427.631Z",
    fill: "#005AC6"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.308 282.56C525.308 284.364 519.322 285.824 511.938 285.824C504.556 285.824 498.569 284.364 498.569 282.56C498.569 280.757 504.556 279.294 511.938 279.294C519.322 279.294 525.308 280.757 525.308 282.56Z",
    fill: "url(#paint15_linear)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.641 282.178H513.234V262.982H510.641V282.178Z",
    fill: "#1F83FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.478 259.55C519.478 263.723 516.103 267.103 511.938 267.103C507.775 267.103 504.4 263.723 504.4 259.55C504.4 255.38 507.775 252 511.938 252C516.103 252 519.478 255.38 519.478 259.55Z",
    fill: "#005AC6"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.424 330.744C502.424 333.571 500.138 335.86 497.319 335.86C494.497 335.86 492.212 333.571 492.212 330.744V317.106C492.212 314.282 494.497 311.99 497.319 311.99C500.138 311.99 502.424 314.282 502.424 317.106V330.744Z",
    fill: "#005AC6"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.665 330.744C531.665 333.571 529.38 335.86 526.558 335.86C523.739 335.86 521.454 333.571 521.454 330.744V317.106C521.454 314.282 523.739 311.99 526.558 311.99C529.38 311.99 531.665 314.282 531.665 317.106V330.744Z",
    fill: "#005AC6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.032 302.692C390.452 299.685 388.117 297 385.08 297H308.736C306.242 297 304.129 298.838 303.784 301.308L296.795 351.308C296.375 354.315 298.711 357 301.747 357H378.092C380.586 357 382.698 355.162 383.043 352.692L390.032 302.692Z",
    fill: "#C5DFFF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.108 334.394L328.899 324.611C331.05 322.463 334.523 322.439 336.703 324.558L339.691 327.462L347.422 319.805C347.564 319.664 347.714 319.53 347.871 319.406C350.275 317.49 353.775 317.89 355.688 320.298L366.883 334.394C335.033 334.394 319.108 334.394 319.108 334.394ZM335.894 320.178C333.992 320.178 332.451 318.635 332.451 316.732C332.451 314.829 333.992 313.286 335.894 313.286C337.795 313.286 339.337 314.829 339.337 316.732C339.337 318.635 337.795 320.178 335.894 320.178Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 573.7,
    y: 268,
    width: 265.601,
    height: 169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0925881 0 0 0 0 0.430615 0 0 0 0 0.573539 0 0 0 0.163298 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 440.046,
    y1: 482.587,
    x2: 425.778,
    y2: 491.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 444.362,
    y1: 506.557,
    x2: 438.945,
    y2: 517.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 446.752,
    y1: 482.566,
    x2: 434.807,
    y2: 501.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 456.535,
    y1: 501.89,
    x2: 453.682,
    y2: 511.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 446.584,
    y1: 481.977,
    x2: 445.308,
    y2: 489.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 456.825,
    y1: 481.352,
    x2: 453.548,
    y2: 491.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 439.216,
    y1: 470.079,
    x2: 425.817,
    y2: 494.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 583.732,
    y1: 482.587,
    x2: 569.464,
    y2: 491.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 579.372,
    y1: 506.557,
    x2: 573.955,
    y2: 517.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 576.913,
    y1: 482.566,
    x2: 564.968,
    y2: 501.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 567.176,
    y1: 501.89,
    x2: 564.324,
    y2: 511.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 577.06,
    y1: 481.977,
    x2: 575.784,
    y2: 489.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 566.893,
    y1: 481.352,
    x2: 563.616,
    y2: 491.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 584.375,
    y1: 470.079,
    x2: 570.976,
    y2: 494.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 511.282,
    y1: 258.449,
    x2: 462.117,
    y2: 361.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 511.754,
    y1: 276.806,
    x2: 510.685,
    y2: 285.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ACFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorState);
export default __webpack_public_path__ + "static/media/error-state.19bd89958d556ac07939a1678ef18f38.svg";
export { ForwardRef as ReactComponent };